// countryFlagsMap.js
const countryFlagsMap = {
    "Afghanistan": "af.svg",
"Albania": "al.svg",
"Algeria": "dz.svg",
"Andorra": "ad.svg",
"Angola": "ao.svg",
"Argentina": "ar.svg",
"Armenia": "am.svg",
"Australia": "au.svg",
"Austria": "at.svg",
"Azerbaijan": "az.svg",
"Bahamas": "bs.svg",
"Bahrain": "bh.svg",
"Bangladesh": "bd.svg",
"Barbados": "bb.svg",
"Belarus": "by.svg",
"Belgium": "be.svg",
"Bermuda": "bm.svg",
"Bhutan": "bt.svg",
"Bolivia": "bo.svg",
"Bosnia and Herzegovina": "ba.svg",
"Botswana": "bw.svg",
"Brazil": "br.svg",
"British Virgin Islands": "vg.svg",
"Brunei": "bn.svg",
"Bulgaria": "bg.svg",
"Cambodia": "kh.svg",
"Cameroon": "cm.svg",
"Canada": "ca.svg",
"Cayman Islands": "ky.svg",
"Chad": "td.svg",
"Chile": "cl.svg",
"China": "cn.svg",
"Colombia": "co.svg",
"Costa Rica": "cr.svg",
"Croatia": "hr.svg",
"Curacao": "cw.svg",
"Cyprus": "cy.svg",
"Czech Republic": "cz.svg",
"Democratic Republic of the Congo": "cd.svg",
"Denmark": "dk.svg",
"Dominica": "dm.svg",
"Dominican Republic": "do.svg",
"Ecuador": "ec.svg",
"Egypt": "eg.svg",
"El Salvador": "sv.svg",
"Estonia": "ee.svg",
"Eswatini": "sz.svg",
"Ethiopia": "et.svg",
"Fiji": "fj.svg",
"Finland": "fi.svg",
"France": "fr.svg",
"Georgia": "ge.svg",
"Germany": "de.svg",
"Ghana": "gh.svg",
"Gibraltar": "gi.svg",
"Greece": "gr.svg",
"Greenland": "gl.svg",
"Guatemala": "gt.svg",
"Haiti": "ht.svg",
"Hong Kong": "hk.svg",
"Hungary": "hu.svg",
"Iceland": "is.svg",
"India": "in.svg",
"Indonesia": "id.svg",
"Iran": "ir.svg",
"Iraq": "iq.svg",
"Ireland": "ie.svg",
"Isle of Man": "im.svg",
"Israel": "il.svg",
"Italy": "it.svg",
"Jamaica": "jm.svg",
"Japan": "jp.svg",
"Jordan": "jo.svg",
"Kazakhstan": "kz.svg",
"Kenya": "ke.svg",
"Kosovo": "xk.svg",
"Kuwait": "kw.svg",
"Kyrgyzstan": "kg.svg",
"Latvia": "lv.svg",
"Lebanon": "lb.svg",
"Lesotho": "ls.svg",
"Liberia": "lr.svg",
"Liechtenstein": "li.svg",
"Lithuania": "lt.svg",
"Luxembourg": "lu.svg",
"Macao": "mo.svg",
"Macedonia": "mk.svg",
"Malawi": "mw.svg",
"Malaysia": "my.svg",
"Maldives": "mv.svg",
"Malta": "mt.svg",
"Mauritius": "mu.svg",
"Mexico": "mx.svg",
"Moldova": "md.svg",
"Monaco": "mc.svg",
"Mongolia": "mn.svg",
"Montenegro": "me.svg",
"Morocco": "ma.svg",
"Myanmar": "mm.svg",
"Namibia": "na.svg",
"Nepal": "np.svg",
"New Zealand": "nz.svg",
"Nicaragua": "ni.svg",
"Nigeria": "ng.svg",
"North Korea": "kp.svg",
"Norway": "no.svg",
"Oman": "om.svg",
"Pakistan": "pk.svg",
"Palestine": "ps.svg",
"Panama": "pa.svg",
"Paraguay": "py.svg",
"Peru": "pe.svg",
"Philippines": "ph.svg",
"Poland": "pl.svg",
"Portugal": "pt.svg",
"Puerto Rico": "pr.svg",
"Qatar": "qa.svg",
"Republic of Côte d'Ivoire": "ci.svg",
"Romania": "ro.svg",
"Russian Federation": "ru.svg",
"Rwanda": "rw.svg",
"Saint Lucia": "lc.svg",
"Saint Vincent and the Grenadines": "vc.svg",
"Saudi Arabia": "sa.svg",
"Scotland": "gb-sct.svg",
"Senegal": "sn.svg",
"Serbia": "rs.svg",
"Seychelles": "sc.svg",
"Sierra Leone": "sl.svg",
"Singapore": "sg.svg",
"Slovakia": "sk.svg",
"Slovenia": "si.svg",
"South Africa": "za.svg",
"South Korea": "kr.svg",
"Spain": "es.svg",
"Sri Lanka": "lk.svg",
"Sudan": "sd.svg",
"Sweden": "se.svg",
"Switzerland": "ch.svg",
"Syria": "sy.svg",
"Taiwan": "tw.svg",
"Tajikistan": "tj.svg",
"Tanzania": "tz.svg",
"Thailand": "th.svg",
"The Netherlands": "nl.svg",
"Togo": "tg.svg",
"Trinidad and Tobago": "tt.svg",
"Tunisia": "tn.svg",
"Turkey": "tr.svg",
"Uganda": "ug.svg",
"Ukraine": "ua.svg",
"United Arab Emirates": "ae.svg",
"United Kingdom": "gb.svg",
"United States": "us.svg",
"Uruguay": "uy.svg",
"Uzbekistan": "uz.svg",
"Venezuela": "ve.svg",
"Vietnam": "vn.svg",
"Yemen": "ye.svg",
"Zambia": "zm.svg",
"Zimbabwe": "zw.svg"
  };
  
  export default countryFlagsMap;
  